/**
 * Adlandırılmış renkler (durum, görev sütunu, etiket). Sunucu bu adları saklar
 * (gray, red, … orange); burada kendi tonlarımıza çevrilir.
 *
 * Rozet zemini ve yazısı rengin zeminle / metinle karışımından üretilir: açık temada
 * yazı koyulaşır, koyu temada açılır — kontrast iki temada da korunur.
 */
export const NAMED_COLORS = {
  gray: '#868E96', red: '#E03131', pink: '#D6336C', grape: '#AE3EC9', violet: '#7048E8',
  indigo: '#4263EB', blue: '#1C7ED6', cyan: '#1098AD', teal: '#0C8599', green: '#2F9E44',
  lime: '#66A80F', yellow: '#F08C00', orange: '#E8590C',
} as const

export type NamedColor = keyof typeof NAMED_COLORS

export const NAMED_COLOR_LABELS: Record<NamedColor, string> = {
  gray: 'Gri', red: 'Kırmızı', pink: 'Pembe', grape: 'Mor', violet: 'Menekşe', indigo: 'Çivit', blue: 'Mavi',
  cyan: 'Camgöbeği', teal: 'Deniz mavisi', green: 'Yeşil', lime: 'Limon', yellow: 'Sarı', orange: 'Turuncu',
}

/** Adı ya da doğrudan hex'i dolu renge çevirir; bilinmeyen ad gri olur. */
export function solid(color: string | null | undefined): string {
  if (!color) return NAMED_COLORS.gray
  if (color.startsWith('#')) return color
  return NAMED_COLORS[color as NamedColor] ?? NAMED_COLORS.gray
}

/** Açık rozet zemini (tema uyumlu). */
export function tint(color: string | null | undefined): string {
  return `color-mix(in srgb, ${solid(color)} 14%, var(--nx-surface))`
}

/** Açık zemin üstündeki okunur yazı rengi (tema uyumlu). */
export function ink(color: string | null | undefined): string {
  return `color-mix(in srgb, ${solid(color)} 72%, var(--nx-fg))`
}
